/**
 * type guard to confirm if an object is a notification
 */
export const isNotification = data => {
  return typeof data.ctaProxyUrl === 'string';
};